import React from "react";
import LoginLayout from "../../component/appLayouts/login";
import LoginForm from "../../component/loginForm";

function Login() {
  return (
    <div id="login-page" className="login-page ">
      
      <LoginLayout title={"Connexion"}>
        <LoginForm />
      </LoginLayout>
    </div>
  );
}

export default Login;
